const ustatuses = [
  { name: 'Избиратель' },
  { name: 'Наблюдатель' },
  { name: 'Представитель СМИ' },
  { name: 'Член избирательной комиссии' },
  { name: 'Кандидат' },
];
const regions = [
  { name: 'Алтайский край', id: '22' },
  { name: 'Амурская область', id: '28' },
  { name: 'Архангельская область', id: '29' },
  { name: 'Астраханская область', id: '30' },
  { name: 'Белгородская область', id: '31' },
  { name: 'Брянская область', id: '32' },
  { name: 'Владимирская область', id: '33' },
  { name: 'Волгоградская область', id: '34' },
  { name: 'Вологодская область', id: '35' },
  { name: 'Воронежская область', id: '36' },
  { name: 'город Москва', id: '77' },
  { name: 'город Санкт-Петербург', id: '78' },
  { name: 'Еврейская автономная область', id: '79' },
  { name: 'Забайкальский край', id: '75' },
  { name: 'Ивановская область', id: '37' },
  { name: 'Иные территории', id: '99' },
  { name: 'Иркутская область', id: '38' },
  { name: 'Кабардино-Балкарская Республика', id: '7' },
  { name: 'Калининградская область', id: '39' },
  { name: 'Калужская область', id: '40' },
  { name: 'Камчатский край', id: '41' },
  { name: 'Карачаево-Черкесская Республика', id: '9' },
  { name: 'Кемеровская область', id: '42' },
  { name: 'Кировская область', id: '43' },
  { name: 'Костромская область', id: '44' },
  { name: 'Краснодарский край', id: '23' },
  { name: 'Красноярский край', id: '24' },
  { name: 'Курганская область', id: '45' },
  { name: 'Курская область', id: '46' },
  { name: 'Ленинградская область', id: '47' },
  { name: 'Липецкая область', id: '48' },
  { name: 'Магаданская область', id: '49' },
  { name: 'Московская область', id: '50' },
  { name: 'Мурманская область', id: '51' },
  { name: 'Ненецкий автономный округ', id: '83' },
  { name: 'Нижегородская область', id: '52' },
  { name: 'Новгородская область', id: '53' },
  { name: 'Новосибирская область', id: '54' },
  { name: 'Омская область', id: '55' },
  { name: 'Оренбургская область', id: '56' },
  { name: 'Орловская область', id: '57' },
  { name: 'Пензенская область', id: '58' },
  { name: 'Пермский край', id: '59' },
  { name: 'Приморский край', id: '25' },
  { name: 'Псковская область', id: '60' },
  { name: 'Республика Адыгея (Адыгея)', id: '1' },
  { name: 'Республика Алтай', id: '2' },
  { name: 'Республика Башкортостан', id: '3' },
  { name: 'Республика Бурятия', id: '4' },
  { name: 'Республика Дагестан', id: '5' },
  { name: 'Республика Ингушетия', id: '6' },
  { name: 'Республика Калмыкия', id: '8' },
  { name: 'Республика Карелия', id: '10' },
  { name: 'Республика Коми', id: '11' },
  { name: 'Республика Марий Эл', id: '12' },
  { name: 'Республика Мордовия', id: '13' },
  { name: 'Республика Саха (Якутия)', id: '14' },
  { name: 'Республика Северная Осетия-Алания', id: '15' },
  { name: 'Республика Татарстан (Татарстан)', id: '16' },
  { name: 'Республика Тыва', id: '17' },
  { name: 'Республика Хакасия', id: '19' },
  { name: 'Ростовская область', id: '61' },
  { name: 'Рязанская область', id: '62' },
  { name: 'Самарская область', id: '63' },
  { name: 'Саратовская область', id: '64' },
  { name: 'Сахалинская область', id: '65' },
  { name: 'Свердловская область', id: '66' },
  { name: 'Смоленская область', id: '67' },
  { name: 'Ставропольский край', id: '26' },
  { name: 'Тамбовская область', id: '68' },
  { name: 'Тверская область', id: '69' },
  { name: 'Томская область', id: '70' },
  { name: 'Тульская область', id: '71' },
  { name: 'Тюменская область', id: '72' },
  { name: 'Удмуртская Республика', id: '18' },
  { name: 'Ульяновская область', id: '73' },
  { name: 'Хабаровский край', id: '27' },
  { name: 'Ханты-Мансийский автономный округ', id: '86' },
  { name: 'Челябинская область', id: '74' },
  { name: 'Чеченская Республика', id: '20' },
  { name: 'Чувашская Республика - Чувашия', id: '21' },
  { name: 'Чукотский автономный округ', id: '87' },
  { name: 'Ямало-Ненецкий автономный округ', id: '89' },
  { name: 'Ярославская область', id: '76' },
];

export default { ustatuses, regions };



// WEBPACK FOOTER //
// ./src/config/config.js